<template>
    <accordion>
        <template slot="toggle-title">
            <div class="w-full flex flex-col pr-md lg:flex-row md:w-2/5 md:pr-0">
                {{ lang('Router','Router') }}
            </div>
        </template>
        <template v-slot:toggle-content="{ toggle }">
            <edit-router-settings-modal @success="updateRouterSettings" />
            <edit-router-password-modal />

            <tabs v-if="routerSettings['24ghz'] !== undefined" @selectedTab="setSelectedTab">
                <tab name="2,4GHz" :selected="true">
                    <div class="overflow-x-auto">
                        <table class="table responsive-stack is-service mt-0">
                            <tr>
                                <th class="w-2/5">{{ lang('Typ','Type') }}</th>
                                <td>{{ routerName }}</td>
                                <td />
                            </tr>
                            <tr>
                                <th class="w-2/5">{{ lang('Nätverksnamn (SSID)','Network name (SSID)') }}</th>
                                <td>{{ routerSettings['24ghz'].ssid }}</td>
                                <td />
                            </tr>
                            <tr>
                                <th class="w-2/5">{{ lang('Kanal','Channel') }}</th>
                                <td>{{ routerSettings['24ghz'].channel }}</td>
                                <td class="relative">
                                    <a
                                        v-tooltip="channelHelpText"
                                        class="btn-help ml-auto"
                                    >
                                        <span>?</span>
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <th class="w-2/5">{{ lang('Wifi-lösenord','Wifi-password') }}</th>
                                <td>********</td>
                                <td />
                            </tr>
                        </table>
                    </div>

                    <div class="flex">
                        <button
                            class="btn btn-md is-ghost mb-lg ml-auto"
                            @click="$modal.show('edit-router-settings', {
                                routerSettings: routerSettings,
                                editBand: selectedBandKey,
                                availableChannels: availableChannels
                            })"
                        >
                            {{ lang('Redigera wifi-inställningar', 'Edit wifi-settings') }}
                        </button>
                    </div>
                </tab>
                <tab v-if="hasSupportFor5ghz" name="5GHz">
                    <div class="overflow-x-auto">
                        <table class="table responsive-stack is-service mt-0">
                            <tr>
                                <th class="w-2/5">{{ lang('Typ', 'Type') }}</th>
                                <td>{{ routerName }}</td>
                            </tr>
                            <tr>
                                <th class="w-2/5">{{ lang('Nätverksnamn', 'Network name') }} (SSID)</th>
                                <td>{{ routerSettings['5ghz'].ssid }}</td>
                                <td />
                            </tr>
                            <tr>
                                <th class="w-2/5">{{ lang('Kanal', 'Channel') }}</th>
                                <td>{{ routerSettings['5ghz'].channel }}</td>
                                <td class="relative">
                                    <a v-tooltip="channelHelpText" class="btn-help ml-auto">
                                        <span>?</span>
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <th class="w-2/5">Wifi-{{ lang('lösenord', 'password') }}</th>
                                <td>********</td>
                                <td />
                            </tr>
                        </table>
                    </div>

                    <div class="flex">
                        <button
                            class="btn btn-md is-ghost mb-lg ml-auto"
                            @click="$modal.show('edit-router-settings', {
                                routerSettings: routerSettings,
                                editBand: selectedBandKey,
                                availableChannels: availableChannels
                            })"
                        >
                            {{ lang('Redigera wifi-inställningar', 'Edit wifi-settings') }}
                        </button>
                    </div>
                </tab>
            </tabs>

            <div class="flex items-center mb-xl bg-neutral-lighter rounded py-md px-lg">
                <font-awesome-icon icon="info-circle" class="text-lg text-accent-yellow  mr-lg" />
                <div class="text-sm">
                    {{ lang(
                        'Du behöver återansluta alla dina enheter, om du har valt att ändra nätverksnamn eller lösenord.',
                        'You will need to manually re-connect all your devices if you\'ve changed the network name or password.'
                    ) }}
                </div>
            </div>

            <div class="action-bar flex-col-reverse">
                <button
                    class="btn btn-md is-ghost inverted md:mr-auto"
                    @click="toggle"
                >
                    {{ lang('Stäng', 'Close') }}
                </button>

                <button
                    class="btn btn-md is-primary mb-lg md:mb-0 md:ml-2xl"
                    @click="$modal.show('edit-router-password')"
                >
                    {{ lang('Ändra router-lösenord', 'Change router-password') }}
                </button>
            </div>
        </template>
    </accordion>
</template>
<script>
    import EditRouterSettingsModal from './EditRouterSettingsModal';
    import EditRouterPasswordModal from './EditRouterPasswordModal';

    export default {
        components: {
            EditRouterSettingsModal,
            EditRouterPasswordModal,
        },
        props: {
            channels: {
                required: true,
                type: Object,
            },
            routerName: {
                required: true,
                type: String,
            },
        },
        data() {
            return {
                routerSettings: {},
                selectedTab: '2,4GHz',
                channelHelpText: lang(
                    'Din enhets frekvenskanal',
                    'Frequency channel of your device'
                ),
            };
        },
        computed: {
            hasSupportFor5ghz() {
                return this.routerSettings['5ghz'] !== undefined
                    && this.routerSettings['5ghz'].has5ghz === true;
            },
            availableChannels() {
                if (this.selectedTab === '5GHz') {
                    return this.channels['5Ghz'];
                }

                return this.channels['2,4Ghz'];
            },
            selectedBandKey() {
                if (this.selectedTab === '5GHz') {
                    return '5ghz';
                }

                return '24ghz';
            },
        },
        created() {
            this.fetch();
        },
        methods: {
            setSelectedTab(tab) {
                this.selectedTab = tab.name;
            },
            async fetch() {
                try {
                    let result = await axios.get(
                        route('front.my-pages.api.router.get-settings')
                    );

                    result = result.data[0];

                    if (result.error !== 0) {
                        throw 'Fel vid hämtning av router-information';
                    }

                    this.routerSettings = result.data;
                } catch (error) {
                    flash_error(lang('Kunde inte ladda routerinställningar','Was not able to load router settings'));
                }
            },
            updateRouterSettings({ ssid, channel, band }) {
                this.routerSettings[band].ssid = ssid;
                this.routerSettings[band].channel = channel;

                this.$modal.hide('edit-router-settings');

                flash_success();
            },
        },
    };
</script>